import type { SkipLinkTarget } from './skipLinkTargets'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { getAvailableSkipLinkTargets } from './getAvailableSkipLinkTargets'

export function useAvailableSkipLinkTargets(): SkipLinkTarget[] {
  const router = useRouter()
  const [availableTargets, setAvailableTargets] = useState<SkipLinkTarget[]>([])

  useEffect(() => {
    let frameId = 0

    const update = () => {
      cancelAnimationFrame(frameId)
      frameId = requestAnimationFrame(() => {
        setAvailableTargets(getAvailableSkipLinkTargets())
      })
    }

    update()

    router.events.on('routeChangeComplete', update)

    const observer = new MutationObserver(update)
    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      cancelAnimationFrame(frameId)
      router.events.off('routeChangeComplete', update)
      observer.disconnect()
    }
  }, [router.events])

  return availableTargets
}
